import React, {useState, useContext, useEffect} from "react";
import {useNavigate} from "react-router-dom";
import CssBaseline from "@mui/material/CssBaseline";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import loginimg from "../../assets/images/track.jpg";
import BLimg from "../../assets/images/betterLife.png";
import BGimg from "../../assets/images/bgLogo.svg";
import {
    CustomButton,
    CustomText,
    CustomTitle,
} from "../../components/Custom";

const LogOutPage = () => {

    const navigate = useNavigate();

    const tryLogin = () => {
        navigate("/")
    }

    return (
        <Box>
            <Box py={5} px={15}>
                <Grid
                    container
                    component="main"
                    sx={{height: "650px", border: "2px solid", borderRadius: "5px"}}
                >
                    <CssBaseline/>

                    <Grid
                        item
                        xs={false}
                        sm={7}
                        md={7}
                        sx={{
                            backgroundImage: `url(${loginimg})`,
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "800px",
                            height: "100%",
                            backgroundPosition: "center",

                            // backgroundBlendMode: "multiply",
                        }}
                    >
                        <Grid
                            container
                            sx={{
                                backgroundColor: "rgba(220, 220, 220, 0.4)",
                                height: "100%",
                                textAlign: "center",
                            }}
                        >
                            <Box>
                                <Box sx={{display: "flex", justifyContent: "space-between"}}>
                                    <Box
                                        component="img"
                                        sx={{
                                            height: 130,
                                            width: 120,
                                            p: 1,
                                            // maxHeight: { xs: 233, md: 167 },
                                            // maxWidth: { xs: 250, md: 150 },
                                        }}
                                        alt="Babbangona logo"
                                        src={BGimg}
                                    />
                                    <Box
                                        component="img"
                                        sx={{
                                            height: 120,
                                            width: 110,
                                            mx: 1,
                                            // maxHeight: { xs: 233, md: 167 },
                                            // maxWidth: { xs: 250, md: 150 },
                                        }}
                                        alt="Better Life"
                                        src={BLimg}
                                    />
                                </Box>

                                <CustomTitle
                                    sx={{fontSize: "75px", lineHeight: "80px", mt: 6}}
                                >
                                    Data Request Tracker
                                </CustomTitle>
                                <CustomText sx={{px: 2, fontWeight: "600"}}>3.0</CustomText>
                            </Box>
                        </Grid>
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        sm={5}
                        md={5}
                        component={Paper}
                        elevation={2}
                        square
                    >
                        <Box
                            sx={{
                                py: 10,
                                px: 8,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "left",
                            }}
                        >
                            <form>
                                <CustomTitle
                                    component="h1"
                                    variant="h4"
                                    sx={{mb: 5, fontSize: "35px"}}
                                >
                                    Logged Out
                                </CustomTitle>
                                <CustomText component="p" variant="subtitle">
                                    You are currently logged out
                                </CustomText>
                                <Box noValidate sx={{mt: 1}}>
                                    <CustomButton
                                        onClick={tryLogin}
                                        fullWidth
                                        variant="contained"
                                        sx={{
                                            my: 4,
                                            background: "#58CC02",
                                        }}
                                    >
                                        Login
                                    </CustomButton>

                                    <Grid
                                        container
                                        sx={{
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >

                                    </Grid>
                                </Box>
                            </form>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
};
export default LogOutPage;
